import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-supp-inv-search-subitem',
  templateUrl: './supp-inv-search-subitem.component.html',
  styleUrls: ['./supp-inv-search-subitem.component.css']
})
export class SuppInvSearchSubitemComponent implements OnInit {

  model = { 'main_item_name': '', 'sub_item_no': '', 'item_cat_id': '', 'item_subcat_id': '' };
  private dp = [];
  item_cat_list = [];
  item_subcat_list = [];
  displayedColumns = ['sub_item_no', 'main_item_name', 'main_item_name_en', 'item_cat_name', 'item_subcat_name', 'choose'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<SuppInvSearchSubitemComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {

    let query = "SELECT * FROM `item_cat` WHERE `status`='1'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.item_cat_list = data.data['list'];
      });
    let query1 = "SELECT * FROM `item_subcat` WHERE `status`='1'";
    let obj1 = { cmd: 'getList', query: query1 };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.item_subcat_list = data.data['list'];
      });
  }

  search() {
    let condition = "";

    if (this.model['main_item_name'] != '')
      condition = " AND (`main_item`.`main_item_name` LIKE '%" + this.model['main_item_name'] +
        "%' OR `main_item`.`main_item_name_en` LIKE '%" + this.model['main_item_name'] + "%')";

    if (this.model['sub_item_no'] != '')
      condition += " AND `sub_item`.`sub_item_no` LIKE '%" + this.model['sub_item_no'] + "%'";

    if (this.model['item_cat_id'] != '')
      condition += " AND `item_cat`.`item_cat_id` ='" + this.model['item_cat_id'] + "'";

    if (this.model['item_subcat_id'] != '')
      condition += " AND `item_subcat`.`item_subcat_id` ='" + this.model['item_subcat_id'] + "'";

    let query = "SELECT `sub_item`.*, `main_item`.`main_item_id`, `main_item`.`main_item_name`, `main_item`.`main_item_name_en`, " +
      "`item_subcat`.`item_subcat_name`, `item_cat`.`item_cat_name` FROM `sub_item`, " +
      "`main_item`, `item_subcat`, `item_cat` WHERE `sub_item`.`status` = '1' AND " +
      "`sub_item`.`main_item_id` = `main_item`.`main_item_id`" + condition +
      " AND `main_item`.`item_subcat_id` = `item_subcat`.`item_subcat_id` AND " +
      "`item_subcat`.`item_cat_id` = `item_cat`.`item_cat_id`";

    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
    this.model = { 'main_item_name': '', 'sub_item_no': '', 'item_cat_id': '', 'item_subcat_id': '' };
  }

  choose(row) {

    this.dialog_data = {
          'sub_item_no': row['sub_item_no'],
          'main_item_name': row['main_item_name'],
          'main_item_name_en': row['main_item_name_en'],
          'item_cat_name': row['item_cat_name'],
          'item_subcat_name': row['item_subcat_name'],
          'sub_item_id': row['sub_item_id'],
          'unit_id': row['unit_id']
        };

    this.dialogRef.close(this.dialog_data);
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
